module.exports = __webpack_public_path__ + "static/media/checkbox_.b204aab4.svg";